.questionInputContainer {
    height: 120px;
    position: relative;
    flex: 1;
    min-width: 0;
    background: #FFFFFF;
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.14), 0px 0px 2px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.questionInputTextArea {
    width: 100%;
    line-height: 40px;
    margin-top: 10px;
    margin-bottom: 10px;
    margin-left: 12px;
    margin-right: 12px;
}

.questionInputAttachmentButton {
    width: 24px;
    height: 24px;
    padding: 0px;
    margin: 0px 0px 12px 0px;
    border: none;
    background: transparent;
    position: relative;
}

.questionInputAttachmentIcon {
    width: 24px;
    height: 24px;
}

.attachmentCount {
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: red;
    color: white;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
}

.questionInputSendButtonContainer {
    position: absolute;
    right: 24px;
    bottom: 20px;
    position: static;
}

.questionInputSendButton {
    width: 24px;
    height: 23px;
}

.SendButtonDisabled {
    pointer-events: none;
    width: 24px;
    height: 23px;
}

.questionInputSendButtonDisabled {
    width: 24px;
    height: 23px;
    background: none;
    color: #424242;
}

.questionInputBottomBorder {
    position: absolute;
    width: 100%;
    height: 4px;
    left: 0%;
    bottom: 0%;
    background: radial-gradient(106.04% 106.06% at 100.1% 90.19%, #0F6CBD 33.63%, #8DDDD8 100%);
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
}

.questionInputOptionsButton {
    cursor: pointer;
    width: 27px;
    height: 30px;
}

.microphoneWrapper {
    position: relative;
    display: flex;
    align-items: flex-end;
    gap: 2px;
}

.questionInputMicrophone {
    position: relative;
    cursor: pointer;
}

.micChevron {
    cursor: pointer;
    padding: 2px;
    display: flex;
    align-items: center;
    opacity: 0.6;
    margin-bottom: 1px;
}

.micChevron:hover {
    opacity: 1;
}

.micDropdown {
    position: absolute;
    bottom: calc(100% + 8px);
    left: 0;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    min-width: 200px;
    max-width: 320px;
    z-index: 100;
    overflow: hidden;
}

.micDropdownItem {
    padding: 8px 12px;
    font-size: 13px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #242424;
}

.micDropdownItem:hover {
    background-color: #f5f5f5;
}

.micDropdownItemSelected {
    color: #0F6CBD;
    font-weight: 600;
}

.micError {
    position: absolute;
    bottom: calc(100% + 8px);
    left: 0;
    background: #FDE7E9;
    border: 1px solid #D13438;
    border-radius: 6px;
    padding: 6px 10px;
    font-size: 12px;
    color: #D13438;
    white-space: nowrap;
    z-index: 100;
}

.questionInputMicrophone::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 34px;
    height: 34px;
    border-radius: 50%;
    background-color: transparent;
    transition: background-color 0.15s ease;
}

.questionInputMicrophone:hover::before {
    background-color: rgba(15, 108, 189, 0.1);
}

.questionInputMicrophoneActive::before {
    background-color: rgba(197, 15, 31, 0.1);
    animation: pulse 1.2s ease-in-out infinite;
}

@keyframes pulse {
    0%, 100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
    50% { transform: translate(-50%, -50%) scale(1.3); opacity: 0.6; }
}


.paperclip {
    position: relative;
    cursor: pointer;
}

.cancelIcon {
    position: relative;
    cursor: pointer;
}

.uploadCountBubble {
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: #D53B3B;
    color: white;
    border-radius: 10px;
    padding: 2px 6px;
    font-size: 12px;
    min-width: 20px;
    text-align: center;
    font-weight: bold;
}

.cancelUploadAndSendContainer {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 8px;
    padding-right: 1rem;
    height: 100%;
}

.cancelContainer {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    height: 100%;
}

.uploadAndSendContainer {
    display: flex;
    align-items: flex-end;
    gap: 1.5rem;
}

.fileListContainer {
    margin-top: 1rem;
}

.fileItem {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    justify-content: space-between;

    overflow: hidden;
}

.fileName {
    margin-right: 0.5rem;
}

.errorIcon {
    color: red;
    margin-right: 0.5rem;
}

.itemActionButtonsContainer {
    display: flex;
    align-items: center;
}

.loadingIndicator {
    margin-right: 0.5rem;
}

.uploadButtonContainer {
    margin-bottom: 1rem;
}

@media screen and (-ms-high-contrast: active),
(forced-colors: active) {
    .questionInputContainer {
        border: 2px solid WindowText;
        margin-bottom: 10px;
        padding: 5px;
        background-color: Window;
        color: WindowText;
    }
}
